module.exports = __webpack_public_path__ + "img/ic_v_emty.fb32c62e.png";